// Lib
import React, { ReactNode } from 'react';
import { get } from 'lodash/fp';

// Components
import ErrorBoundary from '../error/errorBoundary/ErrorBoundary';
import DefaultErrorRenderer from '../error/errorBoundary/DefaultErrorRenderer';
import { useTranslator } from '../i18n/useTranslator';

// Styles
import './FloatingPanelErrorRenderer.scss';

interface ErrorDetailsProps {
    className?: string;
    error?: Error | null;
}

const getErrorDetails = ({ className, error }: ErrorDetailsProps): string => `Popup: ${className}
Error: ${error && error.toString()}
Stack: ${get('stack', error)}`;

const FloatingPanelErrorRenderer = (props: ErrorDetailsProps) => {
    const translate = useTranslator('popup', 'error.floatingPanel');

    return (
        <div>
            <DefaultErrorRenderer
                {...props}
                furtherMessage={translate('retryHint', ' or opening and closing the popup.')}
                className="FloatingPanelErrorRenderer"
                heading={translate('heading', 'Something went wrong')}
                getErrorDetails={getErrorDetails}
            />
        </div>
    );
};

interface FloatingPanelErrorBoundaryProps {
    children: ReactNode;
}

const FloatingPanelErrorBoundary = (props: FloatingPanelErrorBoundaryProps) => {
    const { children } = props;

    return (
        <ErrorBoundary ErrorRenderer={FloatingPanelErrorRenderer} getErrorMessage={getErrorDetails}>
            {children}
        </ErrorBoundary>
    );
};

export default FloatingPanelErrorBoundary;
